import { Component } from '@angular/core';

@Component({
  selector: 'app-cybersecurity',
  templateUrl: './cybersecurity.component.html',
  styleUrls: ['./cybersecurity.component.scss']
})
export class CybersecurityComponent {

}
